// src/features/arrivals/lib/singleScopeHotel.ts
//
// The one hotel the scope in effect resolves to, or null: a selection of
// exactly one hotel, or no selection (= every hotel of the user) when the user
// only has one. Single-hotel users never see the selector, so their selection
// is always null and «Pantalla de pared» used to be hidden from them.
export const singleScopeHotelId = (
  selectedHotelIds: string[] | null,
  allHotels: { id: string }[]
): string | null => {
  if (selectedHotelIds && selectedHotelIds.length > 0) {
    return selectedHotelIds.length === 1 ? selectedHotelIds[0] : null;
  }
  return allHotels.length === 1 ? allHotels[0].id : null;
};
